import { FC } from "react"
import { IoCheckbox } from "react-icons/io5"
export interface IWhyChooseCS {
  blok: {
    title?: string
    subtitle?: string
    items?: { icon?: string; title: string; text: string }[]
  }
}

const WhyChooseCS: FC<IWhyChooseCS> = ({ blok }) => (
  <section className="py-10 md:py-14 px-6 max-w-[1240px] mx-auto bg-secondary-100">
    <div>
      {blok.title && (
        <h2
          className="font-merriweather text-3xl leading-[48px] lg:text-[40px] lg:leading-[72px] md:text-center mb-2"
          dangerouslySetInnerHTML={{ __html: blok.title }}
        />
      )}
      {blok.subtitle && (
        <p className="md:text-center text-lg text-gray-700 max-w-2xl mx-auto mb-12 md:mb-6">
          {blok.subtitle}
        </p>
      )}

      <div className={`grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 md:pt-5`}>
        {blok.items?.map((item, index) => (
          <div key={index} className="flex items-start px-0 md:p-5">
            <div>
              <div className="inline-flex items-center">
                <span aria-hidden className="mr-3 text-xl leading-none">
                  <IoCheckbox className="text-green-500" />
                </span>
                <h3 className="font-medium text-xl mb-1">{item.title}</h3>
              </div>

              <p className="text-base text-gray-800">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default WhyChooseCS
